var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.56152 1.04297V12.9266",
    stroke: "#848E9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0459 1H5.49829C6.51598 1 7.58667 1.053 8.47715 1.54065C9.95068 2.35692 10.3323 4.4559 9.28282 5.75982C9.0496 6.05664 8.74217 6.30046 8.41354 6.47008C7.9789 6.7033 7.43826 6.84111 6.7916 6.84111",
    stroke: "#848E9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0459 13.0009H5.49829C6.50537 13.0009 8.12732 13.0009 9.0708 12.5875C10.0991 12.1317 10.82 11.1988 10.9366 10.0645C10.9578 9.88426 10.9578 9.70405 10.9472 9.53443C10.9366 9.30121 10.8942 9.08919 10.8412 8.87717C10.6397 8.17751 10.1415 7.60506 9.50544 7.25523C8.83758 6.8842 8.12732 6.8418 7.38525 6.8418H2.91166",
    stroke: "#848E9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbold);
export default __webpack_public_path__ + "static/media/chatbold.8c75e4d4b1a456bf9dba47eee9370615.svg";
export { ForwardRef as ReactComponent };